import { render } from "./gmPermission.vue?vue&type=template&id=0bfd22ff&scoped=true"
const script = {}

import "./gmPermission.vue?vue&type=style&index=0&id=0bfd22ff&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfd22ff"]])

export default __exports__